const managersConfig = {
  '80f53ef6-6373-11ea-bc55-0242ac130003': {
    denyChangeClub: true
  }
}

export function getManagersConfig(clubId) {
  return managersConfig[clubId]
}



// WEBPACK FOOTER //
// ./src/components/Managers/managersConfig.js